import { createStore } from 'stimulus-store';

/**
 * Store for filtered device items based on user-selected filter criteria.
 * 
 * This store contains the subset of devices from allDevicesStore that match
 * the current filter criteria applied by the Item Filters Controller.
 * 
 * The Items Table Controller subscribes to this store and renders the
 * Bootstrap table with the filtered device list.
 * 
 * Store States:
 * - []: Empty array indicates either:
 *   - No filters have been applied yet (initial state)
 *   - Filters applied but no devices match the criteria
 *   - All filters cleared, waiting for user to click Apply
 * - [...]: Array of devices matching current filter criteria
 * 
 * Data Flow:
 * 1. User clicks "Apply" button
 * 2. Item Filters Controller reads filter values from form
 * 3. Controller filters devices from allDevicesStore
 * 4. Controller updates this store with filtered results
 * 5. Items Table Controller reacts to store change and re-renders table
 * 
 * Note: This store is populated only when the user explicitly clicks "Apply"
 * or "Clear Filters". It does not auto-populate on page load.
 */
export const filteredItemsStore = createStore({
    name: 'filteredItemsStore',
    type: Array,
    initialValue: []
});